<template>
  <div>
    <v-card outlined class="pa-2">
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <div class="mb-2 text-body-1">
              <span class="red-6--text font-weight-bold">{{ kycPrefix }}</span>
            </div>
            <v-textarea
              placeholder="請輸入文字訊息"
              :value="editableContent"
              outlined
              rows="5"
              no-resize
              :error="showError"
              :error-messages="errorMessage"
              persistent-hint
              hint="內文1～70字為1點，71～140字為2點，141～210字為3點⋯依此類推。"
              :messages="countText"
              @input="handleInput"
            />
            <div class="grey-7--text text-body-2 mt-4">
              <div class="red-6--text font-weight-medium">
                重要說明：因應政府反詐政策規定，簡訊必須在內文清楚標示發訊者身分。因此系統已於簡訊開頭加上「{{ kycPrefix }}」，已計入字數且無法刪除，否則可能會被判定為詐騙簡訊而導致發送失敗。
              </div>
              <div>
                ▲備註一：輸入的字數與實際發送的字數可能有些微差異，將會依照實際發送的字數來扣點。
              </div>
              <div>
                ▲備註二：近期政府推動反詐騙宣導，若內文涉及敏感字眼，可能會有被阻擋發送之風險。 若有遇到發送不成功的情況，請再洽詢
                <a :href="$enum.DENTCO_CS_LINE" target="_blank" class="link_blue--text">牙醫小幫手客服</a>。
              </div>
              <div>
                ▲備註三：承上則，每封客製化簡訊將會經由電信企業審核，無詐騙疑慮才能送出。審核時間長度不一，無法立即送達，敬請耐心等候。
              </div>
              <div>
                ▲備註四：請勿在訊息內放入網址連結，否則可能會被判定為詐騙簡訊而導致發送失敗。
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <div class="mt-12">
      <v-btn color="primary" @click="submit">{{ $t('SendStep.confirmContent') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MessageEditor',

  props: {
    value: {
      type: String,
      required: null
    },
  },

  data() {
    return {
      editableContent: '',
      showError: false,
      errorMessage: ''
    }
  },

  computed: {
    ...mapGetters(['clinicUser', 'userInfo']),

    kycPrefix() {
      if (!this.userInfo) return ''

      if (this.clinicUser) {
        // 診所登入：取得診所名稱
        return `${this.userInfo.name}通知：`
      } else {
        // 醫師登入：取得 (alias || name) + title
        const doctorName = this.userInfo.alias || this.userInfo.name
        const title = this.userInfo.title || ''
        return `${doctorName}${title}通知：`
      }
    },

    countText() {
      if (this.value)
        return `已編輯 ${this.value.length} 字`
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        // 從完整內容中移除前綴，只顯示可編輯部分
        if (newValue && newValue.startsWith(this.kycPrefix)) {
          this.editableContent = newValue.substring(this.kycPrefix.length)
        } else if (newValue) {
          this.editableContent = newValue
        } else {
          this.editableContent = ''
        }
      }
    }
  },

  methods: {
    handleInput(inputValue) {
      // 清除錯誤提示
      this.showError = false
      this.errorMessage = ''

      // 將可編輯內容與前綴組合後傳給父組件
      this.editableContent = inputValue || ''
      const fullContent = this.kycPrefix + this.editableContent
      this.$emit('update:value', fullContent)
    },

    submit() {
      // 如果只有前綴沒有實際內容，不能進入下一步
      if (!this.editableContent || !this.editableContent.trim()) {
        this.showError = true
        this.errorMessage = '請輸入訊息內容'
        return
      }
      this.showError = false
      this.errorMessage = ''
      this.$emit('nextStep')
    }
  }
};
</script>

<style scoped>
/* Your styles here */
</style>
